import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enComponents from "./locales/components.en.json";
import frComponents from "./locales/components.fr.json";
import hrComponents from "./locales/components.hr.json";
import enErrors from "./locales/domain_errors.en.json";
import frErrors from "./locales/domain_errors.fr.json";
import hrErrors from "./locales/domain_errors.hr.json";
import en from "./locales/translations.en.json";
import fr from "./locales/translations.fr.json";
import hr from "./locales/translations.hr.json";

export const defaultNS = "translations";
export const resources = {
  en: {
    translations: { ...en, ...enErrors },
    components: enComponents,
  },
  fr: {
    translations: { ...fr, ...frErrors },
    components: frComponents,
  },
  hr: {
    translations: { ...hr, ...hrErrors },
    components: hrComponents,
  },
};

const lng = process.env.NODE_ENV === "test" ? "fr" : navigator.language || "fr";

void i18n.use(initReactI18next).init({
  resources,
  lng,
  fallbackLng: "fr",
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ["navigator"],
    caches: [],
  },
});

export default i18n;
